// extracted by mini-css-extract-plugin
export var animationContainer = "_c1-0";
export var asteriskIcon = "_c1-8";
export var conversationLeftSection = "_c1-4";
export var conversationListItem = "_c1-3";
export var conversationMiddleSection = "_c1-5";
export var conversationRightSection = "_c1-6";
export var detailsContent = "_c1-1";
export var listContainer = "_c1-7";
export var modalContent = "_c1-2";